import { createContext, useContext } from 'react';
import { noop } from '../../utils/noop.js';

var ColorMode = /*#__PURE__*/function (ColorMode) {
  ColorMode["Light"] = "light";
  ColorMode["Dark"] = "dark";
  return ColorMode;
}({});
var ThemeContext = /*#__PURE__*/createContext({
  mode: ColorMode.Light,
  updateMode: noop
});
var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

export { ColorMode, ThemeContext as default, useTheme };
//# sourceMappingURL=ThemeContext.js.map
